import "./TopArea.css";

import {Link} from "react-router-dom";
import TopNav from "./TopNav";

function TopArea() {
  // TODO: Don't hard-code this, and combine with `baseURL` in ComicContent.
  const logoURL = 'https://www.neorice.com/images/logo_temp.png';
  return (
    <div id="top_container">
      <TopNav />
      <div id="top">
        <Link to='/'>
          <img src={logoURL} alt='Hero Oh Hero' />
        </Link>
      </div>
    </div>
  );
}

export default TopArea;